import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

import { Card } from 'core/components/card';
import NotificationIconGreen from 'core/assets/svg/info-dark-green.svg';
import FormList from 'core/components/form-list';
import { FormField } from 'core/components/form';
import { useRouteHelper } from 'core/hooks/use-route-helper';
import Resident from './resident';
import AddResident from './add-resident';

import useStyles from './household-residents.styles';

const HouseholdResidents = ({ disabled }) => {
  const classes = useStyles();
  const { inOfferEditRoute } = useRouteHelper();

  const notification = (
    <Grid className={classes.warningContainer}>
      <Card className={classes.infoCard}>
        <img src={NotificationIconGreen} className={classes.iconSmall} alt="Notification Icon" />
        <Grid className={classes.notificationContentWithTitle}>
          <p className={classes.titleText}>Please include all household residents</p>
          Include children and non-driving relatives, even if they’re away at college or on military service. This
          ensures PIP protection for everyone in case of a car accident.
        </Grid>
      </Card>
      <FormField
        id="auto.pipResidentsConfirmation"
        name="auto.pipResidentsConfirmation"
        type="checkbox"
        label="I confirm that all household residents are included."
        mode="light"
        xs={12}
      />
    </Grid>
  );

  return (
    <Grid>
      <FormList
        disabled={disabled}
        id="nonDrivers"
        secondaryId="drivers"
        item={Resident}
        addForm={AddResident}
        title="Household residents"
        notification={inOfferEditRoute ? notification : null}
      />
    </Grid>
  );
};

HouseholdResidents.propTypes = {
  disabled: PropTypes.bool
};

HouseholdResidents.defaultProps = {
  disabled: false
};

export default HouseholdResidents;
